import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '@app/core/app-config';
import { AppsService } from '@app/shared/services/apps/apps.service';
import { TitleService } from '@app/shared/services/title/title.service';

@Component({
  standalone: false,
  selector: 'sbnb-mailchimp',
  templateUrl: './mailchimp.component.html',
  styleUrls: ['./mailchimp.component.scss'],
})
export class MailchimpComponent implements OnInit {
  confirmationCode: string;
  connected: boolean;
  lists: any[];
  selectedList: any;
  learnMoreUrl = `https://my.hospitable.com/support-documentation/article/4596812-how-do-i-integrate-with-mailchimp`;
  loading: boolean;
  saveStatus: number;
  meta: any;

  mailchimpClientId = config.MAILCHIMP_CLIENT_ID;
  mailchimpRedirectUrl = config.MAILCHIMP_CLIENT_REDIRECT;

  constructor(
    private titleService: TitleService,
    private appsService: AppsService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.titleService.manuallySet('MailChimp');
    this.loading = true;

    this.confirmationCode = this.route.snapshot.queryParamMap.get('code');

    if (this.confirmationCode) {
      this.appsService.createMailchimpIntegration(this.confirmationCode).subscribe((res) => {
        if (res.error) {
          return;
        }
        // Remove the code from the URL
        const url = this.router.createUrlTree([], { relativeTo: this.route }).toString();

        this.location.go(url);

        this.getLists();
      });
    } else {
      this.getLists();
    }
  }

  getLists() {
    this.appsService.getMailchimpLists().subscribe((res: any) => {
      if (res.connected === false) {
        this.connected = false;
      } else {
        this.connected = true;
        this.lists = res.data;
        this.meta = res.meta;
      }

      let selected = null;

      if (this.lists && this.lists.length > 0) {
        selected = this.lists.find((list) => list.selected === true);
      }

      if (selected) {
        this.selectedList = selected.id;
      }

      this.loading = false;
    });
  }

  connect() {
    window.open(
      `https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${this.mailchimpClientId}&redirect_uri=${this.mailchimpRedirectUrl}`,
      '_self'
    );
  }

  disconnect() {
    this.appsService.disconnectMailchimpIntegration().subscribe((res) => {
      this.connected = false;
    });
  }

  learnMore() {
    window.open(this.learnMoreUrl, '_blank');
  }

  updateSelectedList(newListId: string) {
    this.saveStatus = 1;

    this.appsService.updateMailchimpSelectedList(newListId).subscribe((res) => {
      this.saveStatus = 2;
      setTimeout(() => {
        this.saveStatus = null;
      }, 2000);
    });
  }
}
